import React, { useEffect } from "react";
import { IonApp } from "@ionic/react";
import Router from "./router";
import { ToastProvider } from "@agney/ir-toast";
import ApiErrorToaster from "./components/Shared/ApiErrorToaster/ApiErrorToaster";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
// import '@ionic/react/css/padding.css';
// import '@ionic/react/css/float-elements.css';
// import '@ionic/react/css/text-alignment.css';
// import '@ionic/react/css/text-transformation.css';
// import '@ionic/react/css/flex-utils.css';
// import '@ionic/react/css/display.css';

/* Theme variables */

import "bootstrap/dist/css/bootstrap.min.css";
import "primeicons/primeicons.css";
import "./styles/scss/main.scss";
import { loggedInUserService } from "./services/loggedInUser.service";
import { pushNotificationService } from "./services/PushNotification.service";
import { StorageService } from "./services";
import { ReminderAlertService } from "./services/ReminderAlert.service";

import {  setupIonicReact } from '@ionic/react';

setupIonicReact({
  mode: 'md',
  animated: false
});

const App: React.FC = () => {
  const isTokenValid = JSON.parse(
    StorageService.getStorageItem(localStorage, "isLoggedIn")
  );
  if (isTokenValid) {
    loggedInUserService.setLoggedInUserData();
    ReminderAlertService.getRemindersFromServer(1);
  }
  useEffect(() => {
    pushNotificationService.registerWebServiceWorkerOnPageReload();
  }, []);
  return (
    <IonApp>
      <ToastProvider value={{ duration: 3000, position: "middle" }}>
        {/* Turns every reported API failure into a toast. Mounted here, inside
            the provider, so it also covers the login screen. */}
        <ApiErrorToaster />
        <Router />
      </ToastProvider>
    </IonApp>
  );
};

export default App;
